import { SchemeElementInfo } from '@buseditor/types'
import { useTheme } from '@mui/material'
import { Group, Rect, Text } from 'react-konva'
import React from 'react'

export function StaticSchemeElement(rectProps: SchemeElementInfo) {
    const theme = useTheme()

    return (
        <>
            <Group
                x={rectProps.x}
                y={rectProps.y}
                width={rectProps.width}
                height={rectProps.height}
                rotation={rectProps.rotation}>
                <Rect
                    strokeWidth={1}
                    stroke={theme.palette.text.primary}
                    {...rectProps}
                    x={0}
                    y={0}
                    width={rectProps.width}
                    height={rectProps.height}
                    rotation={undefined}
                    cornerRadius={10} />
                <Text
                    text={rectProps.name}
                    x={0}
                    y={0}
                    width={rectProps.width}
                    height={rectProps.height}
                    rotation={0}
                    fontSize={Math.min(18, Math.max(12, Math.min(rectProps.height, rectProps.width) / 2))}
                    fill={theme.palette.text.primary}
                    align={'center'}
                    verticalAlign={'middle'} />
            </Group>
        </>
    )
}

export function StaticSchemeTextElement(rectProps: SchemeElementInfo) {
    const theme = useTheme()

    return (
        <Text
            text={rectProps.name}
            x={rectProps.x}
            y={rectProps.y}
            width={rectProps.width}
            rotation={rectProps.rotation}
            fontSize={18}
            fill={theme.palette.text.primary}
            align={'center'}
            verticalAlign={'middle'} />
    )
}